export let getWay='https://service.dameiweb.com'
